import React from 'react';
import Text from 'Components/Text';
import moment from 'moment';

export default ({
  submissionDate,
  approvalDate,
  formulatorNumber,
  baseFormulaBaseOilNumber,
  engineType,
  isReadAcrossFormula,
  description,
}) => {
  return (
    <section className='scene_section'>
      <header>General Info</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Submission Date'
        value={submissionDate && moment(submissionDate).format('MM / DD / YYYY')}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Approval Date'
        value={approvalDate && moment(approvalDate).format('MM / DD / YYYY')}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary _width_pc_100'
        textClassName='text__text_primary'
        label='Formulation Number'
        value={formulatorNumber}
      />
      {isReadAcrossFormula && (
        <Text
          mainWrapperClassName='text__wrapper_primary _margin_right_30'
          textClassName='text__text_primary'
          label='Read Across Source'
          value={baseFormulaBaseOilNumber}
        />
      )}
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Engine Oil Type'
        value={engineType}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary  _width_pc_100'
        textClassName='text__text_primary'
        label='Description'
        value={description}
      />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/Details/GeneralInformation.jsx